
import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import {
  BoxStatusType,
  LeadType, Operation, OperationChild,
} from '@/types';
import { isTaskCompleted, isTaskFailed } from '@/helpers';

moment.locale('it');

@Component
export default class PlanMixin extends Vue {
  @Prop(Object) readonly operation!: Operation;
  @Prop(Number) readonly childId!: number;

  get operationChild(): OperationChild | null {
    return this.operation?.children
      && this.childId in this.operation.children
      && this.operation.children[this.childId]
      ? this.operation.children[this.childId] : null;
  }

  get childProjectType(): LeadType | null {
    if (!this.operationChild) return null;
    return this.operationChild.type;
  }

  get hasP(): boolean {
    return this.operationChild?.p === 'done' || this.operationChild?.p === 'na';
  }

  get hasC(): boolean {
    return this.operationChild?.c === 'done' || this.operationChild?.c === 'na';
  }

  get pHasNotes(): boolean {
    return this.operationChild?.pHasNotes === true;
  }
  get cHasNotes(): boolean {
    return this.operationChild?.cHasNotes === true;
  }

  get columnClass(): string {
    if (isTaskCompleted(this.operationChild, 'V')) return 'completed';
    if (isTaskFailed(this.operationChild, 'V')) return 'error';
    if (this.childProjectType === 'elettrica-figlia' && this.hasP) return 'completed';
    if (this.childProjectType === 'termica-figlia' && this.hasP && this.hasC) return 'completed';
    return '';
  }

  chipColor(value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return 'grey lighten-2';

      case 'done':
        return 'statusDone';

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  chipOutlined(value: BoxStatusType | null): boolean {
    switch (value) {
      case 'na':
        return true;

      default:
        break;
    }

    return false;
  }

  tooltipColor(value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return 'grey';

      case 'done':
        return 'success';

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  tooltipText(prefix: string, value: BoxStatusType | null): string {
    switch (value) {
      case null:
      case 'todo':
        return `${prefix} (assente)`;

      case 'na':
        return `${prefix} (non applicabile)`;

      case 'waiting':
        return `${prefix} (in attesa di terzi)`;

      default:
        break;
    }
    return prefix;
  }

  get pChipColor(): string {
    return this.operationChild ? this.chipColor(this.operationChild?.p) : '';
  }
  get cChipColor(): string {
    return this.operationChild ? this.chipColor(this.operationChild?.c) : '';
  }

  get pChipOutlined(): boolean {
    return this.operationChild ? this.chipOutlined(this.operationChild?.p) : false;
  }
  get cChipOutlined(): boolean {
    return this.operationChild ? this.chipOutlined(this.operationChild?.c) : false;
  }

  get pTooltipColor(): string {
    return this.operationChild ? this.tooltipColor(this.operationChild?.p) : '';
  }
  get cTooltipColor(): string {
    return this.operationChild ? this.tooltipColor(this.operationChild?.c) : '';
  }

  get supplyLabel(): string | null {
    return this.operation && 'supplyLabel' in this.operation ? this.operation.supplyLabel : null;
  }

  get powerDetails1(): string | null {
    return this.operationChild && 'powerDetails1' in this.operationChild ? this.operationChild.powerDetails1 : null;
  }

  get powerDetails2(): string | null {
    return this.operationChild && 'powerDetails2' in this.operationChild ? this.operationChild.powerDetails2 : null;
  }

  get powerDetails3(): string | null {
    return this.operationChild && 'powerDetails3' in this.operationChild ? this.operationChild.powerDetails3 : null;
  }

  get powerDetails4(): string | null {
    return this.operationChild && 'powerDetails4' in this.operationChild ? this.operationChild.powerDetails4 : null;
  }

  get powerDetails5(): string | null {
    return this.operationChild && 'powerDetails5' in this.operationChild ? this.operationChild.powerDetails5 : null;
  }

  get pTooltipText(): string {
    let text = this.operationChild ? this.tooltipText('Progetto', this.operationChild?.p) : 'Progetto';
    text = `<strong>${text}</strong>`;

    if (this.supplyLabel === 'Fornitura definitiva') {
      if (this.powerDetails1) text += `<br>Potenza Moduli FV/Campo FV [kWp]: ${this.powerDetails1}`;
      if (this.powerDetails2) text += `<br>Potenza Inverter [kW]: ${this.powerDetails2}`;
      if (this.powerDetails3) text += `<br>Potenza batteria lato AC [kW]: ${this.powerDetails3}`;
      if (this.powerDetails4) text += `<br>Potenza ai fini della conness. (P nom.) [kW]: ${this.powerDetails4}`;
      if (this.powerDetails5) text += `<br>Potenza ai fini della conness. (P imm.) [kW]: ${this.powerDetails5}`;
    }

    return text;
  }

  get cTooltipText(): string {
    return this.operationChild ? this.tooltipText('Computo metrico', this.operationChild?.c) : 'Computo metrico';
  }

  onEdit() {
    console.log('OperationPlan: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
